// NOTE: Dependencies: jQuery

(function ($) {
	$.fn.lmAccordion = function(options) {
		// check is dom element is defined 
		if (!this.length) {
			return false;
		}
		
		// Default settings are set here.
		var settings = $.extend({
			speed: 400,
			selectorWrapper: 'accordion__item',
			selectorClass: 'accordion__title',
			selectorContent: 'accordion__content',
			activeClass: 'accordion__item--open',
			openAllBtn: 'accordion__toggle',
			inProgress: false
		}, options);
		
		// These are all the methods available for the plugin.
		var methods = {};

		var allItemsOpen = false;
			
		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		}

		methods.openItem = function ($clicked, openAll) {
			// Cache selector
			if (openAll) {
				var selectedWrapper = $clicked.find('.' + settings.selectorWrapper);
			} else {
				var selectedWrapper = $clicked.closest('.' + settings.selectorWrapper);
			}

			// If the item is alread open, close it.
			if(!selectedWrapper.hasClass(settings.activeClass) || openAll){
				// Show new content and add the active class.
				selectedWrapper.find('.' + settings.selectorContent).stop(true, true).slideDown(settings.speed, function() {
					selectedWrapper.addClass(settings.activeClass);
				});
			}
		}

		methods.closeActive = function ($context) {
			// Cache selector
			var currentActive = $context.find('.' + settings.activeClass);
			
			// If no accordion options are open.
			if(currentActive.length < 1) {
				setTimeout(function(){
					settings.inProgress = false;
				}, settings.speed);
			} else {
				// Hide old content and remove the active class.
				currentActive.find('.' + settings.selectorContent).stop(true, true).slideUp(settings.speed, function() {
					currentActive.removeClass(settings.activeClass);
					settings.inProgress = false;
				});
			}
		}

		// Click event function
		methods.changeActiveContent = function($context, $clicked) {
			// If there are no items currently toggling, start the process.
			if(!settings.inProgress) {
				settings.inProgress = true;

				// Close the active item if needed.
				methods.closeActive($context);

				if (allItemsOpen) {
					allItemsOpen = false;
					setTimeout(function(){
						methods.openItem($clicked, false);
					},settings.speed);
				} else {
					methods.openItem($clicked, false);
				}				
			}
		}

		// Toggle all event
		methods.toggleAll = function($context, $this) {
			// Set toggle state
			if(!allItemsOpen) {
				allItemsOpen = true;
				methods.openItem($context, true);
				$this.text($this.data('close'));
			} else {
				allItemsOpen = false;
				methods.closeActive($context);
				$this.text($this.data('open'));
			}
		}

		// Bind events
		methods.events = function($context) {
			$context.find('.' + settings.selectorClass).off('click.lmAccordion');

			$context.find('.' + settings.selectorClass).on('click.lmAccordion', function(evt) {
				evt.preventDefault();

				// Item clicked.
				var $currentContext = $(evt.currentTarget);
				// Run change function.
				methods.changeActiveContent($context, $currentContext);

				$context.find('.' + settings.openAllBtn).text($context.find('.' + settings.openAllBtn).data('open'));
			});

			$context.find('.' + settings.openAllBtn).off('click.lmAccordion').on('click.lmAccordion', function(evt) {
				evt.preventDefault();

				// Run change function.
				methods.toggleAll($context, $(this));
			});
		}
		

		// On load function
		methods.initContext = function($context) {
			methods.setCurrentSettings($context);
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Run once methods when jquery plugin is called.
		methods.events(this);

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			var $this = $(this);

			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($this);
		});
	};
}(jQuery));